import { observer } from "mobx-react-lite";
import { LineChart } from "@mui/x-charts/LineChart";
import React, { useCallback, useMemo } from "react";
import { ChartsReferenceLine, MarkElement, MarkElementProps } from "@mui/x-charts";
import { PricesStorage, PriceTier } from "../../services/shop/PricesStorage";
import { DatasetType } from "@mui/x-charts/internals";
import { translationService } from "../../services/translation/TranslationService";

export interface CoinChartProps {
  coins: number;
  pricesStorage: PricesStorage;
}

export default observer(function CoinPriceChart(props: CoinChartProps) {
  const { coins, pricesStorage } = props;
  const closest = (array: any[], value: number) => {
    return array.reduce((prev, next) =>
        Math.abs(next - value) < Math.abs(prev - value) ? next : prev
    );
  };
  const index = closest(pricesStorage.coinAxis, coins);

  const mark = useCallback(
    (props: MarkElementProps) => {
      const marked = useMemo(() => props.dataIndex === index, [props.dataIndex, index]);
      return <MarkElement {...props} shape={marked ? "cross" : "circle"} />;
    },
    [index]
  );

  const x = pricesStorage.coinAxis;
  const y = pricesStorage.currencyAxis;

  const dataset: DatasetType = useMemo(
    () =>
      x.map((value: number, index: number) => {
        return { x: value, y: y[index] };
      }),
    [x, y]
  );

  return (
    <LineChart
      onHighlightChange={() => {}}
      width={1100}
      height={550}
      highlightedItem={{ dataIndex: index }}
      dataset={dataset}
      xAxis={[
        {
          dataKey: "x",
          labelStyle: { transform: "translate(0, 12px)", fontWeight: "bold" },
          tickLabelStyle: { transform: "rotate(-50deg) translate(-20px)" },
          label: "Credits",
        },
      ]}
      series={[{ dataKey: "y", color: "#1976d2", showMark: false }]}
      yAxis={[
        {
          label: "Euro",
          labelStyle: {
            transform: "rotate(-90deg) translate(-240px, -315px)",
            fontWeight: "bold",
          },
        },
      ]}
      slots={{ mark: mark }}
      sx={{ pl: 4 }}
    >
      <ChartsReferenceLine x={index} lineStyle={{ stroke: "#fdb462", strokeWidth: 4 }} />
      <ChartsReferenceLine labelAlign="end" label={pricesStorage.calculateCurrency(index).toString() + " €"} y={pricesStorage.calculateCurrency(index)} lineStyle={{ stroke: "#fdb462", strokeWidth: 4 }} />
      {pricesStorage.prices.map((priceTier: PriceTier) => (
        <>
          {/* <ChartsReferenceLine y={priceTier.minimum} lineStyle={{ strokeDasharray: "5 5" }} /> */}
          <ChartsReferenceLine
            x={priceTier.minimum}
            lineStyle={{ strokeDasharray: "5 5" }}
            label={"" + priceTier.discount + "%"}
            labelAlign="start"
          />
        </>
      ))}
    </LineChart>
  );
});
